import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getItem, isTokenExpired } from "@helpers/helpers";
import { STORAGE_KEY } from "@constants/constants";

export const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const authenticated = getItem(STORAGE_KEY.USER);
  const tokenExpired = isTokenExpired();

  useEffect(() => {
    if (tokenExpired) {
      localStorage.clear();
      navigate('/login');
    }

    if (!authenticated) {
      navigate("/login");
    }
  }, [authenticated, navigate]);

  return <React.Fragment>{children}</React.Fragment>;
};
